import axios from 'axios'
import { useUserStore } from 'obst/user-store'
import obfn from '@/utils/obfn'
import obui from '@/utils/obui'
import { isLBE } from '@/utils/obcfg'
import route from '@/utils/obroute'
import i18n from '@/i18n/index.ts'

import { toast_error } from './obtoast'
const t = i18n.global.t

let baseURL
const urlbHost = 'url-builder.truemetrics.cn'
if (document.location.hostname == urlbHost) {
  baseURL = `https://api.url-builder.truemetrics.cn`
} else {
  // obdev
  baseURL = `https://dev-api.url-builder.truemetrics.cn`
  if (isLBE) {
    baseURL = 'http://localhost:3331/api/urlb'
  }
}

const obaxios = axios.create({
  baseURL: baseURL,
  timeout: 60000,
  headers: {
    // "Content-Type": "application/json;charset=utf-8",
    'Content-Type': 'multipart/form-data',
  },
})

// request interceptor
obaxios.interceptors.request.use(
  function (config) {
    const userStore = useUserStore()
    // 设置Token
    if (/^\/task\/(login|validate_email|reset_password_one|register|reset_password_two)/.test(config.url)) {
      config.headers.Authorization = void 0
    } else {
      config.headers.Authorization = `token ${userStore.token}`
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?'
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        const part = encodeURIComponent(propName) + '='
        if (value !== null && typeof value !== 'undefined') {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              const params = propName + '[' + key + ']'
              const subPart = encodeURIComponent(params) + '='
              url += subPart + encodeURIComponent(value[key]) + '&'
            }
          } else {
            url += part + encodeURIComponent(value) + '&'
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    if (!isLBE) {
      config.url = `/${t('api_path')}/api${config.url}`
    }
    obfn.log('request_url', config.url)
    return config
  },
  function (error) {
    // obfn.log('axiosReqErr',error)
    return Promise.reject(error)
  },
)

// response interceptor
obaxios.interceptors.response.use(
  //obopt 通用错误提示&具体错误提示
  (response) => {
    const status = response.data?.status
    const msg = response.data?.msg || response.data?.message || response.data?.detail
    if (!status && msg) {
      // 错误信息
      toast_error(msg)
    }
    return response
  },
  function (error) {
    const userStore = useUserStore()
    obfn.log('axioxErr', error.response)
    const errRes = error?.response
    const errCode = errRes?.status,
      errText = errRes?.statusText
    const errData = errRes?.data,
      errStatus = errData?.status,
      errMsg = errData?.msg || errData?.detail
    const reqPath = errRes?.config?.url
    obfn.log('errMsg', reqPath + '\n', errMsg)
    obfn.log('errText', errText)
    obfn.log('errStatus', errStatus)

    // 判断是否登录失效
    if (errCode == 401) {
      // 跳转登录页面
      route.navTo('login')
      userStore.tokenSetExpired()
      return Promise.reject(error)
    }
    //消息提示
    toast_error(errMsg)
    if (error.message && error.message.includes('timeout')) {
      obui.error(t('error.timeout'))
      return Promise.reject({ genericError: 'Timeout' })
    } else {
      return Promise.reject(error)
    }
  },
)

export default obaxios
